import { Box, TextField, Typography } from '@mui/material';
import { AzulIconButton } from '@the-ksquare-group/azul-ds';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import React, { Fragment, useState } from 'react';
import Button from 'components/Button/Button';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';
import { ModalProps } from '../ModalFactory';
import { useDuplicateDocumentMutation, useDuplicateDocumentVersionMutation } from 'features/document/documentApi';
import {
  useDuplicateDocumentTemplateVersionMutation,
  useDuplicateTemplateMutation,
} from 'features/template/templateApi';

export default function DuplicateModalContent(props: ModalProps) {
  const { onClose, modalData } = props;
  const { documentId, id, isTemplate, isVersion, name } = modalData;
  const [duplicateHandler, setDuplicateHandler] = useState(`Copy - ${name}`);
  const [duplicateDocument] = useDuplicateDocumentMutation();
  const [duplicateTemplate] = useDuplicateTemplateMutation();
  const [duplicateDocumentVersion] = useDuplicateDocumentVersionMutation();
  const [duplicateDocumentTemplateVersion] = useDuplicateDocumentTemplateVersionMutation();

  const handleDuplicateFile = async () => {
    if (isTemplate && !isVersion) {
      await duplicateTemplate({
        id,
        newDocumentName: duplicateHandler,
      });
    }
    if (isVersion) {
      if (isTemplate) {
        await duplicateDocumentTemplateVersion({ versionId: id, documentId, name: duplicateHandler });
      } else {
        await duplicateDocumentVersion({ versionId: id, documentId, name: duplicateHandler });
      }
    } else {
      await duplicateDocument({
        id,
        newDocumentName: duplicateHandler,
      });
    }
    onClose();
  };

  return (
    <Fragment>
      <Box sx={{ position: 'absolute', right: ' 20px', top: '29px' }}>
        <AzulIconButton
          icon={<CloseRoundedIcon sx={{ color: colorPalette.primaryBlue }} />}
          tooltipTitle='Close'
          onClick={onClose}
        />
      </Box>
      <Typography
        id='modal-modal-title'
        variant='h6'
        component='h2'
        fontSize='24px'
        sx={{ color: docGeniusPalette.neutralGray }}
      >
        Make a Copy
      </Typography>
      <Typography id='modal-modal-description' sx={{ mt: 2 }}>
        Name
      </Typography>
      <Box sx={{ marginTop: '10px' }} />
      <TextField
        fullWidth
        placeholder='Copy - Oct 20, 2023, 8:04 am'
        name='Rename'
        value={duplicateHandler}
        onChange={e => setDuplicateHandler(e.target.value)}
      />
      <Box sx={{ marginTop: '80px' }} />
      <Box
        sx={{
          display: 'flex',
          position: 'absolute',
          bottom: '33px',
          right: '32px',
        }}
      >
        <Button variant='secondary' onClick={props.onClose}>
          Cancel
        </Button>
        <Box sx={{ marginRight: '20px' }} />
        <Button onClick={handleDuplicateFile}>Make a Copy</Button>
      </Box>
    </Fragment>
  );
}

